import {Injectable} from '@angular/core';

@Injectable()
export class LoggerService {
  static log(message: any, ...optionalParams: any[]) {
    console.log(message, optionalParams);
  }

  static debug(message: any, ...optionalParams: any[]) {
    // tslint:disable-next-line:no-console
    console.debug(message, optionalParams);
  }

  static error(message: any, ...optionalParams: any[]) {
    console.error(message, optionalParams);
  }
}
